"use client";

import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";

import { cn } from "./utils";
import { buttonVariants } from "./button";

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: React.ComponentProps<typeof DayPicker>) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-4", className)}
      classNames={{
        root: "relative w-fit",
        months: "flex flex-col gap-4 sm:flex-row",
        month: "flex w-full flex-col gap-4",
        month_caption: "relative flex h-9 w-full items-center justify-center",
        caption_label: "text-sm font-semibold capitalize text-foreground",
        nav: "absolute inset-x-4 top-4 flex items-center justify-between",
        button_previous: cn(
          buttonVariants({ variant: "ghost", size: "icon" }),
          "size-9 rounded-full text-muted-foreground hover:text-foreground",
        ),
        button_next: cn(
          buttonVariants({ variant: "ghost", size: "icon" }),
          "size-9 rounded-full text-muted-foreground hover:text-foreground",
        ),
        month_grid: "w-full border-collapse",
        weekdays: "flex",
        weekday: "w-10 pb-2 text-center text-xs font-medium text-muted-foreground",
        week: "mt-1 flex w-full",
        day: "relative size-10 p-0 text-center text-sm",
        day_button: cn(
          buttonVariants({ variant: "ghost" }),
          "size-10 rounded-full p-0 font-normal transition-colors aria-selected:opacity-100",
        ),
        range_start: "rounded-l-full bg-accent",
        range_end: "rounded-r-full bg-accent",
        range_middle: "bg-accent",
        selected:
          "[&>button]:bg-primary [&>button]:font-semibold [&>button]:text-primary-foreground [&>button]:shadow-sm [&>button:hover]:bg-primary/90",
        today:
          "[&>button]:font-semibold [&>button]:text-primary [&>button]:ring-1 [&>button]:ring-primary/35",
        outside: "text-muted-foreground opacity-40",
        disabled: "text-muted-foreground opacity-35",
        hidden: "invisible",
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation, ...props }) =>
          orientation === "left" ? (
            <ChevronLeft className="size-4" {...props} />
          ) : (
            <ChevronRight className="size-4" {...props} />
          ),
      }}
      {...props}
    />
  );
}

export { Calendar };
